module.exports = __webpack_public_path__ + "static/media/prizewinner.b953c55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/prizewinner.png
// module id = 1645
// module chunks = 0